<template>
  <div class="tradesman-career">
    <Row>
      <Col :xs="24"
           :sm="24">
      <Form :model="formItem"
            ref="formItem"
            :inline="true"
            action="javascript:void(0)">
        <FormItem>
          <Select v-model="formItem.uuid"
                  clearable
                  filterable
                  placeholder="选择匠人">
            <Option v-for="item in trandList"
                    :value="item.uuid"
                    :key="item.uuid">{{item.nickname}}
            </Option>
          </Select>
        </FormItem>
        <FormItem>
          <DatePicker type="datetimerange"
                      format="yyyy-MM-dd"
                      :value="datePic"
                      @on-change="changeDate"
                      style="width: 200px"
                      placeholder="开始时间 - 结束时间"></DatePicker>
        </FormItem>
        <FormItem>
          <Input v-model="formItem.key"
                 clearable
                 placeholder="输入名称查找..."></Input>
        </FormItem>
        <FormItem>
          <Button type="primary"
                  @click="renderTable(1)">查找</Button>
        </FormItem>
        <FormItem>
          <Button @click="showModel()"
                  type="success"
                  class="f-l">添加</Button>
        </FormItem>
      </Form>
      </Col>
    </Row>
    <Table border
           :columns="list"
           :data="tablelist"
           :loading="dataloading"></Table>
    <div style="margin: 10px;overflow: hidden">
      <div style="float: right;">
        <Page ref="listPage"
              :total="pages.total"
              :current="pages.page"
              :page-size="pages.size"
              show-elevator
              show-total
              @on-change="changePage()"></Page>
      </div>
    </div>
    <!-- 添加的弹出 -->
    <Drawer :title="title"
            v-model="showModalStatus"
            width="1200"
            :mask-closable="false"
            :styles="styles">
      <Form :model="dataInfo"
            ref="dataInfoValidate"
            :rules="dataInfoValidate"
            action="javascript:void(0)">
        <FormItem label="选择匠人"
                  label-position="top"
                  prop="uuid"
                  style="width:300px">
          <Select v-model="dataInfo.uuid"
                  clearable
                  filterable
                  @on-query-change="SearchTrades"
                  placeholder="选择匠人">
            <Option v-for="item in trandList"
                    :value="item.uuid"
                    :key="item.uuid">{{item.nickname}}
            </Option>
          </Select>
        </FormItem>
        <FormItem label="介绍"
                  prop="title">
          <Input v-model="dataInfo.title"
                 placeholder="最多120个汉字"></Input>
        </FormItem>

        <FormItem label="证书"
                  prop="thumb">
          <upload-thumb v-model="dataInfo.thumb"
                        ref="uploadthumb"
                        :defaultList="thumblist"
                        :autoCropWidth="492"
                        :autoCropHeight="276"
                        :defaultTip="'图片格式:jpg、jpeg、png、gif,建议图片尺寸:492*276'"></upload-thumb>
        </FormItem>
        <FormItem label="时间">
          <DatePicker v-model="dataInfo.time"
                      format="yyyy-MM-dd"
                      placeholder="时间"
                      style="width: 200px"
                      @on-change="changeDateTwo"></DatePicker>
        </FormItem>
      </Form>
      <div class="demo-drawer-footer">
        <Button style="margin-right: 8px"
                @click="showModalStatus = false;step='firstStep'">取消</Button>
        <Button type="primary"
                @click="createInfo('dataInfoValidate')">提交</Button>
      </div>
    </Drawer>
    <!-- 图片查看 start -->
    <viewer :options="viewerOptions"
            :images="viewerImages"
            @inited="inited"
            class="viewerImageWraper"
            ref="viewerImageWraper">
      <template slot-scope="scope">
        <figure class="images">
          <div class="image-wrapper"
               v-for="img in viewerImages"
               :key="img">
            <img class="image"
                 :src="img"
                 :data-source="img"
                 :alt="img"
                 style="display: none;" />
          </div>
        </figure>
      </template>
    </viewer>
    <!-- 图片查看 end -->
  </div>
</template>
  
  <script>
import UploadThumb from "../common/thumb";

export default {
  name: "tradesman-career",
  data () {
    return {
      viewerOptions: {
        toolbar: true,
        url: "data-source"
      },
      viewerImages: [],
      styles: {
        height: "calc(100% - 55px)",
        overflow: "auto",
        paddingBottom: "53px",
        position: "static"
      },
      loading: true,
      dataloading: true,
      thumblist: [],
      datePic: [],
      pages: {
        page: 1,
        size: 10,
        total: 0
      },
      title: '',
      formItem: {
        'key': '',
        uuid: '',
      },
      bigDisplay: '',
      list: [
        {
          title: 'Id',
          key: 'id',
          width: "100px"
        },
        {
          title: '匠人名称',
          key: "tradesman_name"
        },
        {
          title: '时间',
          key: 'time',
        },
        {
          title: '介绍',
          key: 'title',
        },
        {
          title: "证书",
          key: "thumb",
          width: 300,
          render: (h, params) => {
            return h("div", [
              h(
                "Avatar",
                {
                  style: {
                    display: params.row.thumb ? "block" : "none"
                  },
                  props: {
                    src: this.$publicData.ossUrl + params.row.thumb,
                    shape: "square",
                    size: "large",

                    click: ""
                  },
                  nativeOn: {
                    click: () => {
                      this.visible = true;
                      this.imgUrl = this.$publicData.ossUrl + params.row.thumb;
                      this.viewerImages = [this.$publicData.ossUrl + params.row.thumb];
                      this.$viewer.show();
                    }
                  }
                },
                ""
              )
            ]);
          }
        },
        {
          title: '操作',
          key: 'action',
          align: 'left',
          fixed: 'right',
          render: (h, params) => {
            return h('div', [
              h('Button', {
                style: {
                  marginRight: '8px'
                },
                props: {
                  type: 'primary',
                  size: 'small'
                },
                on: {
                  click: () => {
                    this.detail(params.index, params.row.id)
                  }
                }
              }, '编辑'),
              h('Button', {
                style: {
                  marginRight: '8px'
                },
                props: {
                  type: 'error',
                  size: 'small'
                },
                on: {
                  click: () => {
                    this.remove(params.index, params.row.id)
                  }
                }
              }, '删除')
            ]);
          }
        }
      ],
      trandList: [],
      tablelist: [],
      datetime: [],
      dataInfo: {
        title: '',
        link_url: true,
      },
      showModalStatus: false,
      dataInfoValidate: {
        title: [
          { required: true, message: '名称必须填写', trigger: 'blur' },
          { type: 'string', min: 2, max: 120, message: '文字 2 - 120 位长度', trigger: 'blur' }

        ],
      },
    }
  },
  created: function () {
    this.getTradList();
    // 取数据
    this.getTableList();
  },
  components: {
    UploadThumb
  },
  methods: {
    inited (viewer) {
      this.$viewer = viewer;
    },
    getTableList: function () {
      this.$api.tradesmancareer.list({ "page": this.pages.page, "size": this.pages.size }).then(res => {
        this.dataloading = false;
        if (res.code == 200) {
          this.tablelist = res.result.list;
          this.pages.total = res.result.count;
          this.$Message.success(res.msg);
        }
      });
      return;
    },
    changeDate (val) {
      this.datetime = val;
    },
    getTradList: function () {
      this.$api.tradesman.list({ page: 1, size: 10 }).then(res => {
        if (res.code == 200) {
          this.trandList = res.result.list;
        }
      });
    },
    // 展开添加
    showModel () {
      this.title = "添加";
      this.dataInfo = {
        title: '',
      };
      this.thumblist = new Array();
      this.$refs['dataInfoValidate'].resetFields();
      var d1 = new Date();
      this.dataInfo.time = this.formatDate(d1, "yyyy-MM-dd");
      this.showModalStatus = !this.showModalStatus;
    },
    changeDateTwo (val) {
      this.dataInfo.time = val;
    },
    //搜索匠人
    SearchTrades: function (index) {
      this.$api.tradesman.list({ page: 1, size: 10, key: index }).then(res => {
        if (res.code == 200) {
          this.trandList = res.result.list;
        }
      });
    },
    // 添加
    createInfo (name) {
      this.$refs[name].validate((valid) => {
        if (valid) {
          if (this.$refs["uploadthumb"].uploadList.length > 0) {
            this.dataInfo.thumb = this.$refs["uploadthumb"].uploadList[0].url;
          } else {
            this.dataInfo.thumb = null;
          }
          if (this.dataInfo.id == null || this.dataInfo.id == 0) {
            this.$api.tradesmancareer.create(this.dataInfo).then(res => {
              if (res.code == 200) {
                this.getTableList();
              }
              this.loading = false;
              this.$nextTick(() => {
                this.loading = true;
              });
              this.showModalStatus = !this.showModalStatus;
            });
          } else {
            this.$api.tradesmancareer.edit(this.dataInfo).then(res => {
              if (res.code == 200) {
                this.getTableList();
                this.showModalStatus = !this.showModalStatus;
              }
              this.loading = false;
              this.$nextTick(() => {
                this.loading = true;
              });

            });
          }
        } else {
          this.$Message.error('请检查输入的信息是否正确！');
          this.loading = false
          this.$nextTick(() => {
            this.loading = true;
          });
        }
      })
    },
    // 删除
    remove: function (index, id) {
      // 弹出确认框
      this.$Modal.confirm({
        title: '警告',
        content: '<p>此操作不可恢复，三思而后行...</p>',
        onOk: () => {
          this.$api.tradesmancareer.remove({ id: id }).then(res => {
            if (res.code == 200) {
              this.$Message.success(res.msg);
              // this.tablelist.splice(index, 1);
              this.getTableList();
            }
          });
        }
      });
    },
    // 详情
    detail (index, id) {
      this.title = "编辑";
      this.dataInfo = {
        title: '',
      };
      this.thumblist = new Array();
      this.showModalStatus = !this.showModalStatus;
      this.$refs['dataInfoValidate'].resetFields();
      this.$api.tradesmancareer.detail({ id: id }).then(res => {
        this.dataInfo = res.result;
        //处理thumb
        if (this.dataInfo.thumb != null && this.dataInfo.thumb != "") {
          this.thumblist.push({
            name: this.dataInfo.thumb,
            url: this.dataInfo.thumb,
            status: "finished"
          });
        }
      });
    },
    // 翻页
    changePage () {
      this.pages.page = this.$refs['listPage'].currentPage;
      this.renderTable(1);
    },
    // 筛选
    renderTable: function (name) {
      if (name != 1) {
        this.pages.page = 1;
      }
      var bgn_date =
        this.datetime[0] != undefined ? this.datetime[0] : "";
      var end_date =
        this.datetime[1] != undefined ? this.datetime[1] : "";
      this.dataloading = true;
      var ps = { 'key': this.formItem.key, "page": this.pages.page, "size": this.pages.size, uuid: this.formItem.uuid, "bgn_date": bgn_date, "end_date": end_date };
      this.$api.tradesmancareer.list(ps).then(res => {
        this.dataloading = false;
        if (res.code == 200) {
          this.tablelist = res.result.list;
          this.pages.total = res.result.count;
          this.$Message.success(res.msg);
        }
      });
      return;
    },
    formatDate (tt, fmt) {
      if (null == tt || "" == tt) return "";
      var date = new Date(tt);
      let o = {
        "M+": date.getMonth() + 1, // 月份
        "d+": date.getDate(), // 日
        "h+": date.getHours(), // 小时
        "m+": date.getMinutes(), // 分
        "s+": date.getSeconds(), // 秒
        S: date.getMilliseconds() // 毫秒
      };
      if (/(y+)/.test(fmt)) {
        fmt = fmt.replace(
          RegExp.$1,
          (date.getFullYear() + "").substr(4 - RegExp.$1.length)
        );
      }
      for (var k in o) {
        if (new RegExp("(" + k + ")").test(fmt)) {
          fmt = fmt.replace(
            RegExp.$1,
            RegExp.$1.length === 1
              ? o[k]
              : ("00" + o[k]).substr(("" + o[k]).length)
          );
        }
      }
      return fmt;
    },
  },
}
  </script>
  